<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="svgWidth" :height="svgHeight" viewBox="0 0 17.441 16.454" :class="iconCssClass" >
    <g data-id="print" transform="translate(1 1)">
      <path data-id="Path_10" data-name="Path 10" d="M405.842,133.77h3.014v-4.791H393.415v4.791h3.013" transform="translate(-393.415 -123.268)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
      <path data-id="Path_11" data-name="Path 11" d="M397.318,128.3v-5.711h8.461V128.3" transform="translate(-393.828 -122.593)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
      <rect data-id="Rectangle_36" data-name="Rectangle 36" width="9.413" height="5.44" transform="translate(3.016 9.014)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
    </g>
    </svg>
</template>
<script>
export default {
  name: 'print',
  props: ['iconSize', 'iconFill', 'iconStroke', 'iconCssClass'],
  data() {
    return {
      svgWidth: "17.441",
      svgHeight: "16.454",
      svgFill: "none",
      svgStroke: "#236c6c",
      svgStrokeWidth: "2"
    }
  },
  computed: {
    getSize() {
      if (this.iconSize != undefined && this.iconSize !== "") {
        const multiplier = this.iconSize * 1;
        this.svgWidth = this.svgWidth * multiplier
        this.svgHeight = this.svgHeight * multiplier
      }
    },
    getFill() {
      if (this.iconFill !== undefined && this.iconFill !== "") {
        return this.svgFill = this.iconFill
      }
      return this.svgFill
    },
    getStroke() {
      if (this.iconStroke !== undefined && this.iconStroke !== "") {
        this.svgStroke = this.iconStroke
      }
      return this.svgStroke
    }
  },
  mounted() {
    this.getSize
  }
}
</script>
